(function() {
	document.addEventListener("DOMContentLoaded", function() {

		var header = document.getElementById("sign-header");
		var step1  = document.getElementById("sign-step1");
		var step2  = document.getElementById("sign-step2");

		if( header && step1 && step2 ) {

			var input = document.getElementById("price");
			var button= document.getElementById("toNext");

			var titleStet1 = `<h1>Edit Sign</h1>`;
			var titleStet2 = `<h1>For Sale Sign Preview</h1>`;
			
			header.innerHTML = titleStet1;
			if( !input.value ) button.disabled = true;

			input.addEventListener("input", function() {
				button.disabled = false;
			});

			button.addEventListener("click", function() {
				var priceSpan = document.getElementById("PublicListingPrice");
				var hidden = document.createElement("input");
				var price = Formatting.currency(input.value);

				hidden.type  = "hidden";
				hidden.name  = "price";
				hidden.value = price;

				this.parentElement.appendChild(hidden);

				priceSpan.innerText = price;
				header.innerHTML = titleStet2;

				step1.style.display = "none";
				step2.style.display = "block";
			});
		}
	});
})();

$(function() {
	let submissionButtonElement = document.getElementById('for-sale-sign-page__submit-listing-button');
	let targetFormElement = document.getElementById('for-sale-sign-page__submit-listing-form');

	if (submissionButtonElement && targetFormElement) {
		submissionButtonElement.addEventListener('click', (event) => {
            targetFormElement.submit();
		})
	}
});
